import { get } from 'lodash';

import BaseService from './BaseService';

class SubscriptionService extends BaseService {

	constructor() {
		super();
		this.serviceUrl = "/api/rest/billing/subscription";
		this.defaultParams = {
			nestedEntities :[
				"cfValues"
			]
		}
	}

	fetchSubscriptionByCode(subscriptionCode) {
		const url = this.serviceUrl + '/?subscriptionCode=' + subscriptionCode;
		return this.opencellAPI.callApi(url);
	}

	listByCustomer(customerCode) {
		const url = '/api/rest/v2/generic/all/subscription';

    return this.opencellAPI
      .invokeRequest(
        {
          filters: {
            "userAccount.billingAccount.customerAccount.code": customerCode
          },
          nestedEntities: [
            "userAccount.billingAccount.customerAccount",
			"offer",
			"userAccount.name.title",
			"seller",
			"userAccount.billingAccount.billingCycle",
			"userAccount.billingAccount.customerAccount.paymentMethods",
			"userAccount.billingAccount.customerAccount.paymentMethods.customerAccount"
          ]
        },
        url,
        "POST"
      )
      .then(response => ({
        actionStatus: {
          status: 'SUCCESS'
        },
        subscriptions: {
          subscription: get(response, 'data')
        }
      }));
	}

	listByUserAccount(userAccount) {
		const url = this.serviceUrl + '/list?userAccountCode=' + userAccount;
		return this.opencellAPI.callApi(url);
	}

	subscribeService(service) {
		const url = this.serviceUrl + '/activateServices';
		return this.opencellAPI.invokeRequest(service, url, "POST");
	}

	terminateService(serviceInstance) {
		const url = this.serviceUrl + '/terminateServices';
		return this.opencellAPI.invokeRequest(serviceInstance, url, "POST");
	}

	createSubscription(subscription){
		const url = this.serviceUrl + '/';
		return this.opencellAPI.invokeRequest(subscription, url, "POST");
	}

	terminateSubscription(subscription){
		const url = this.serviceUrl + '/terminate';
		return this.opencellAPI.invokeRequest(subscription, url, "POST");
	}

	updateSubscription(subscription) {
		const url = this.serviceUrl + '/';
		return this.opencellAPI.invokeRequest(subscription, url, "PUT");
	}

	findSubscriptionByParams(params) {
		const url = '/api/rest/v2/generic/all/subscription';
    	return this.opencellAPI.invokeRequest(
			{
				...params,
				...this.defaultParams
			}, 
			url, 
			"POST"
		);
	}

	updatePartialSubscription(subscriptionData){
		const url = this.serviceUrl + '/createOrUpdatePartial';
		return this.opencellAPI.invokeRequest({...subscriptionData}, url, "POST");
	}


}

const subscriptionService = new SubscriptionService();

export default subscriptionService;



// WEBPACK FOOTER //
// ./src/opencell/services/SubscriptionService.js